module.exports = __webpack_public_path__ + "static/media/barbell-plate-1000.8dbd1063.png";